<template>
    <div class="password-modal input-full-width">
        <h2 class="text-center">Skift adgangskode</h2>

        <div class="form">
            <div class="grid-x">
                <div class="banner-lock">
                    <icon class="large-svg fill-white" name="locked" />
                </div>
            </div>
        </div>

        <div class="form">
            <div class="grid-x">
                <div class="large-1 medium-1 small-1 cell flexbox-center">
                    <icon class="locked small-svg" name="locked" />
                </div>
                <div class="large-3 medium-3 small-3 cell border-bottom flexbox align-items">
                    <label for="oldPassword">Gammel adgangskode</label>
                </div>
                <div class="auto cell border-bottom">
                    <input ref="useroldpassword" type="password" id="oldPassword" v-model="data.oldPassword">
                </div>
            </div>
        </div>

        <div class="form">
            <div class="grid-x">
                <div class="large-1 medium-1 small-1 cell flexbox-center">
                    <icon class="locked small-svg" name="locked" />
                </div>
                <div class="large-3 medium-3 small-3 cell border-bottom flexbox align-items">
                    <label for="newPassword">Ny adgangskode</label>
                </div>
                <div class="auto cell border-bottom">
                    <input type="password" id="newPassword" v-model="data.newPassword">
                </div>
            </div>
        </div>

        <div class="form">
            <div class="grid-x">
                <div class="large-1 medium-1 small-1 cell flexbox-center">
                    <icon class="locked small-svg" name="locked" />
                </div>
                <div class="large-3 medium-3 small-3 cell border-bottom border-bottom-last flexbox align-items">
                    <label for="repeatPassword">Gentag ny adgangskode</label>
                </div>
                <div class="auto cell border-bottom border-bottom-last">
                    <input type="password" id="repeatPassword" v-model="data.repeatPassword">
                </div>
            </div>
        </div>

        <div class="text-center buttons-modal">
            <a @click="changePassword" :class="{'disabled-button': validatePassword}">Skift</a>
            <a @click="closeModal">Annuller</a>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'administration-modal-newpassword',
    data () {
        return {
            data: {}
        }
    },
    computed: {
        validatePassword () {
            if (this.data.newPassword && this.data.repeatPassword && this.data.newPassword === this.data.repeatPassword) {
                return false
            }
            return true
        }
    },
    methods: {
        ...mapActions({
            resetPassword: 'resetPassword'
        }),
        closeModal () {
            this.$emit('close')
        },
        changePassword () {
            new Promise((resolve, reject) => {
                resolve(this.resetPassword(this.data))
            }).then(() => {
                this.$emit('close')
            })
        }
    },
    mounted () {
        this.$nextTick(() => this.$refs.useroldpassword.focus())
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/administration/administration-modal-newpassword.vue